import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4002Model } from '../kymw4002.model';
import { KYMW4002PromotionModel } from '../vo/kymw4002-promotion.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * プロモーションマスタメンテナンス画面　プロモーションマスタ情報を更新するサービス
 *
 * @export UpdatetPromotionListService
 * @class UpdatetPromotionListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdatetPromotionListService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW4002Model}
   * @memberof UpdatetPromotionListService
   */
  private model: KYMW4002Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {KYMW4002PromotionModel}
   * @memberof UpdatetPromotionListService
   */
  private vo: KYMW4002PromotionModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof UpdatetPromotionListService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdatetPromotionListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PromotionNo: this.vo.promotionNo,
        PromotionInfo : this.vo.promotionInfo,
        MarkCode1: this.vo.markCode1,
        MarkCode2: this.vo.markCode2,
        MarkCode3: this.vo.markCode3,
        MarkCode4: this.vo.markCode4,
        MarkCode5: this.vo.markCode5,
        MultiPublishFlag: this.vo.multiPublishFlag
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof UpdatetPromotionListService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW4002Model>model;
    this.vo = <KYMW4002PromotionModel>vo;
    this.successFunc = successFunc;
    this.send('KYMW40updatePromotionList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdatetPromotionListService
   */
  success(data: any): void {
    this.successFunc(data);
  }

}
